import type { FeatureRoutes } from '@/app/screens'

/* The company admin's welcome page: the first thing they see on their first login. */
export default {
  routes: [
    { path: '/welcome', component: () => import('./WelcomePage.vue'), meta: { perm: 'onboarding.guide', navKey: 'welcome' } },
  ],
} satisfies FeatureRoutes
